routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.paymentOrders', {
      url: __env.routes.paymentOrders,
      template: `<payment-orders sh-ctrl="shCtrl"></payment-orders>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/payments-advances/payment-orders/payment-orders.config.js
 **/